import { useNavigate } from "react-router-dom";
import "./brand_fullname.styles.scss";
const BrandFullName = () => {
  const navigate = useNavigate();
  return (
    <div className="brand-fullname-container">
      <span>
        <span className="brand-emblem-symbol">W</span>
        <span className="brand-emblem-name">aitr</span>
      </span>
    </div>
  );
};
export default BrandFullName;
